import * as React from 'react';
import Radium from 'radium';
import { Alert, Button, FormControl, InputGroup } from 'react-bootstrap';
import { connect } from 'react-redux';

import { changeNewsletterEmail, submitForm, validateField } from './actions';

const RPT = React.PropTypes;

@connect(
  ({ newsletter: { email, submitted, isLoading } }) => ({ email, submitted, isLoading }),
  { changeNewsletterEmail, submitForm, validateField }
)
@Radium
export default class NewsletterForm extends React.Component {
  static propTypes = {
    email: RPT.string.isRequired,
    submitted: RPT.bool.isRequired,
    isLoading: RPT.bool.isRequired,
    changeNewsletterEmail: RPT.func.isRequired,
    submitForm: RPT.func.isRequired,
    validateField: RPT.func
  };

  static defaultProps = {
    validateField: () => null
  };

  handleChange({ target: { name, value } }) {
    const { changeNewsletterEmail } = this.props;

    changeNewsletterEmail({ name, value });
  }

  handleSubmit() {
    const { submitForm } = this.props;

    submitForm();
  }

  handleBlur({ target: { name, value } }) {
    const { validateField } = this.props;

    validateField(name, value);
  }

  render() {
    const { email, submitted, isLoading } = this.props;

    return (<div>
      {submitted && <Alert bsStyle="success">Děkujeme za Váš zájem! Potvrďte, prosím, přihlášení do newsletteru v e-mailu, který jsme Vám zaslali. </Alert>}
      <h2 style={styles}>Chcete informace z první ruky?</h2>
      <InputGroup>
        <FormControl
          name="email"
          value={email}
          onBlur={this.handleBlur.bind(this)}
          onChange={this.handleChange.bind(this)}
          placeholder="E-mail"
        />
        <InputGroup.Button>
          <Button type="submit" disabled={isLoading} bsStyle="success" onClick={this.handleSubmit.bind(this)} block>
            {isLoading ? 'Odesílání...' : 'Ano, chci!'}
          </Button>
        </InputGroup.Button>
      </InputGroup>
    </div>);
  }
}

const styles = {
  color: '#FFF',
  fontSize: '16px'
};



// WEBPACK FOOTER //
// ./src/browser/Feature/components/newsletter_form/index.jsx